module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Auw_AG-408b5aa46596d827607d0cfa4d7d4969.svg";